// extracted by mini-css-extract-plugin
export default {"root":"IconSmartToilet_root__ssvxr"};